import script from "./user-setting-password.vue?vue&type=script&setup=true&lang=js"
export * from "./user-setting-password.vue?vue&type=script&setup=true&lang=js"

import "./user-setting-password.vue?vue&type=style&index=0&id=3d44ddb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d44ddb2"]])

export default __exports__